import { Observable } from "rxjs"
import LabAccount from "./RandomsModel/LabAccount"
import { ObservableFromFetch } from "../ObservableFromFetch"

export default function LabAccountListGetObservable(link: string): Observable<LabAccount[]> {
  const params: string = JSON.stringify({
    Link: link,
    DOT: false,
    IsMarketPlace: true,
    LocationID: 0,
    RegionID: 0,
    SearchBy: "Account Name",
    SearchFor: ""
  })

  return ObservableFromFetch<LabAccount[]>("FFOrderPoolDefinition/GetPoolDefinitionLabAccounts", params)
}
